"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var utils_1 = require("../_internal/utils");
var isArray_1 = tslib_1.__importDefault(require("../isArray"));
var isString_1 = tslib_1.__importDefault(require("../isString"));
var toArray_1 = tslib_1.__importDefault(require("../toArray"));
var concurrent_1 = tslib_1.__importStar(require("./concurrent"));
function sync(length, iterable) {
    var arr, index, i;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                arr = (0, isArray_1.default)(iterable) || (0, isString_1.default)(iterable) ? iterable : (0, toArray_1.default)(iterable);
                index = arr.length - length;
                i = index;
                _a.label = 1;
            case 1:
                if (!(i < arr.length)) return [3 /*break*/, 4];
                if (!arr[i]) return [3 /*break*/, 3];
                return [4 /*yield*/, arr[i]];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                i++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/];
        }
    });
}
function asyncSequential(length, iterable) {
    return tslib_1.__asyncGenerator(this, arguments, function asyncSequential_1() {
        var arr, index, i;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, tslib_1.__await((0, toArray_1.default)(iterable))];
                case 1:
                    arr = _a.sent();
                    index = arr.length - length;
                    i = index;
                    _a.label = 2;
                case 2:
                    if (!(i < arr.length)) return [3 /*break*/, 6];
                    if (!arr[i]) return [3 /*break*/, 5];
                    return [4 /*yield*/, tslib_1.__await(arr[i])];
                case 3: return [4 /*yield*/, _a.sent()];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5:
                    i++;
                    return [3 /*break*/, 2];
                case 6: return [2 /*return*/];
            }
        });
    });
}
function async(length, iterable) {
    var _a;
    var iterator;
    return _a = {},
        _a[Symbol.asyncIterator] = function () {
            return this;
        },
        _a.next = function (_concurrent) {
            if (iterator === undefined) {
                iterator = (0, concurrent_1.isConcurrent)(_concurrent)
                    ? asyncSequential(length, (0, concurrent_1.default)(_concurrent.length, iterable))
                    : asyncSequential(length, iterable);
            }
            return iterator.next(_concurrent);
        },
        _a;
}
function takeRight(l, iterable) {
    if (l < 0) {
        throw new RangeError("'length' must be greater than 0");
    }
    if (iterable === undefined) {
        return function (iterable) {
            return takeRight(l, iterable);
        };
    }
    if ((0, utils_1.isIterable)(iterable)) {
        return sync(l, iterable);
    }
    if ((0, utils_1.isAsyncIterable)(iterable)) {
        return async(l, iterable);
    }
    throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
exports.default = takeRight;
//# sourceMappingURL=takeRight.js.map